import Anchor from '@om-fe/core/components/anchor/anchor';
import Widget from '@om-fe/core/components/widget/widget';
import { I18nContextInterface } from '@om-fe/core/core/i18n/utils';
import withTranslation from '@om-fe/core/core/i18n/with-translation';
import { RouteNames } from '@om-fe/core/core/routing/utils';
import getConfig, { OMFE2ConfigModel } from '@om-fe/core/utils/config';
import { GeneralIcon } from '@om-fe/widgets/dist/components/icon/general-icon';
import React from 'react';
import { compose } from 'redux';

export type HelpSupportLinksProps = I18nContextInterface;

const config: OMFE2ConfigModel & { customConfig: { siteUrl: string } } = getConfig();

class HelpSupportLinksComponent extends React.PureComponent<HelpSupportLinksProps> {
    render() {
        const { gettext, selectedLanguage } = this.props;
        const bettingRulesUrl: string = config.customConfig?.siteUrl ? `${config.customConfig.siteUrl}/${selectedLanguage}${gettext('/betting-rules')}` : '';
        const termsAndConditionsUrl: string = config.customConfig?.siteUrl ? `${config.customConfig.siteUrl}/${selectedLanguage}${gettext('/terms-and-conditions')}` : '';

        return (
            <Widget
                widgetTitle={gettext('Help & Support')}
                icon="security"
                className="HelpAndSupport"
            >
                <ul className="Menu HelpAndSupportMenu">
                    <li className="MenuItem MenuItem--EventResult">
                        <Anchor
                            routeName={RouteNames.eventResultList}
                            className={'MenuItem__Anchor'}
                        >
                            <span className="MenuItem__IconWrapper">
                                <GeneralIcon name="rank" />
                            </span>
                            <span className="MenuItem__Name">
                                <span className="MenuItem__Text">
                                    {gettext('Results page')}
                                </span>
                            </span>
                        </Anchor>
                    </li>
                    {config?.customConfig?.externalBettingRules && bettingRulesUrl ? (
                        <li className="MenuItem MenuItem--BettingRules">
                            <a className="MenuItem__Anchor" target="_top" href={bettingRulesUrl}>
                                <span className="MenuItem__IconWrapper">
                                    <GeneralIcon name="money" />
                                </span>
                                <span className="MenuItem__Name">
                                    <span className="MenuItem__Text">{gettext('Betting Rules')}</span>
                                </span>
                            </a>
                        </li>
                    ) : (
                        <li className="MenuItem MenuItem--BettingRules">
                            <Anchor className="MenuItem__Anchor" routeName={RouteNames.bettingRules}>
                                    <span className="MenuItem__IconWrapper">
                                        <GeneralIcon name="money" />
                                    </span>
                                <span className="MenuItem__Name">
                                        <span className="MenuItem__Text">{gettext('Betting Rules')}</span>
                                    </span>
                            </Anchor>
                        </li>
                    )}
                    {termsAndConditionsUrl &&
                        <li className="MenuItem MenuItem--TermsAndCondition">
                            <a className="MenuItem__Anchor" target="_top" href={termsAndConditionsUrl}>
                                <span className="MenuItem__IconWrapper">
                                    <GeneralIcon name="bet-builder" />
                                </span>
                                <span className="MenuItem__Name">
                                    <span className="MenuItem__Text">{gettext('Terms and conditions')}</span>
                                </span>
                            </a>
                        </li>
                    }
                </ul>
            </Widget>
        );
    }
}

const HelpSupportLinks: React.ComponentClass<{}> = compose(
    withTranslation<HelpSupportLinksProps>(),
)(HelpSupportLinksComponent);
export default HelpSupportLinks;
